// @generated by TypeGen from LogbookModel/Ship/ShipMetadata.swift - DO NOT EDIT

export interface IShipMetadata {
  importError?: string;
  importStatus?: IShipImportStatus;
  importStartedAt?: string;
  importCompletedAt?: string;
  importProgress?: string;
  importedCruises?: number[];
}

export enum IShipImportStatus {
  complete = "complete",
  pending = "pending",
  processing = "processing",
  failed = "failed",
}
